// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCL7mFAR2dqt1-dqD5OivkmzOUraHAa3ZM",
  authDomain: "fang-futures-website.firebaseapp.com",
  projectId: "fang-futures-website",
  storageBucket: "fang-futures-website.firebasestorage.app",
  messagingSenderId: "315897125816",
  appId: "1:315897125816:web:f3620198436232ef1dcd4d",
  measurementId: "G-G5ESB3EH37"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Export the Firebase services for use in other files
export { app, analytics, db, auth };